import React, { Component } from 'react';
import '../App.css';
import { Layout } from 'antd';
import FooterComponent from './footer';
import HeaderComponent from './header';
const { Content } = Layout;
class ErrorPage extends Component {
    render() {
        const { title, errorMessage } = this.props;
        return (
            <Layout style={{ height: "100%" }}>
                <HeaderComponent />
                <Content>
                    <div className="Survey-Holder" style={{ height: "80%" }} >
                        <h3 className="App-header">{errorMessage === undefined ? "There was an issue loading this survey" : errorMessage}</h3>
                    </div></Content>
                <FooterComponent />
            </Layout>
        );
    }
}
export default ErrorPage;